import { styled } from '@mui/material/styles';
import { Card, Stack, Link, Container, Typography } from '@mui/material';
import Page from '../components/Page';
import OtpForm from 'src/sections/authentication/forgot/OtpForm';

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 4),
  padding: theme.spacing(5),
  backgroundColor: theme.palette.drawerBackground
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

export default function OtpVerification() {
  const savedEmail = localStorage.getItem('email');

  return (
    <RootStyle title={`Login | ${process.env.REACT_APP_PROJECTNAME}`}>
      <SectionStyle
        className="login_logo"
        sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'center' }}
      >
        <img src={process.env.REACT_APP_LOGO} alt="login" width={'80%'} />
      </SectionStyle>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 1 }}>
            <Typography
              className="heading_center"
              // variant="h4"
              gutterBottom
              sx={{ color: '#010f58', fontSize:17, fontWeight:"bold" }}
            >
              An OTP has been sent to ({savedEmail}). Please check your inbox to verify your
              account
            </Typography>
          </Stack>
          <OtpForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
